/*
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-01-09 18:11:26 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-01-14 11:38:06 +0800
 * @FilePath     : /ai-agent-lumina/src/utils/enumeration.js
 * @Description  : 枚举
 */

// 等级枚举
export const levelEnum = {
  1: {
    text: '必访',
    label: '必去',
    des: '最高级别标记，表示必去',
    color: 'rgba(255, 100, 91, 1)',
    bgColor: 'rgba(254, 234, 234, 1)'
  },
  2: {
    text: '推荐',
    label: '推荐',
    des: '高级别标记，表示推荐去',
    color: 'rgba(241, 187, 0, 1)',
    bgColor: 'rgba(253, 245, 217, 1)'
  },
  3: {
    text: '候选',
    label: '一般',
    des: '中级别标记，表示候选',
    color: 'rgba(77, 199, 0, 1)',
    bgColor: 'rgba(237, 253, 217, 1)'
  }
}

// 行程类型
export const itineraryType = {
  1: '展 商',
  2: '活 动',
  3: '会 议',
  4: '特别安排',
  5: '邀 约'
}
